import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux/reducers/index';
import {StyledBanner, StyledContentContainer, StyledImg, StyledImgTwo, StyledCustomIcon, StyledBannerFonts, StyledBannerStrongFont, StyledCloseContainer, StyledClose} from './style'
import { language } from '../../utils/language';



const BannerFreeDelivery = (props: any) => {
    const homeState: HomeStateType = useSelector(
		(state: RootState) => state.home
	);
    
    const [isOpenBanner, setIsOpenBanner] = useState(true);   

    if(!isOpenBanner){
        return null
      }
    
    return (
        <>
        <StyledBanner {...props} >
            {props.children}
            <div className="mdc-banner mdc-banner--centered" role="banner" style={{margin:"0 auto"}}>
                <div className="mdc-banner__content"
                    role="alertdialog"
                    aria-live="assertive">
                    <StyledContentContainer className="mdc-banner__graphic-text-wrapper">
                        <StyledImg>
                            <StyledCustomIcon color={props.color} />
                        </StyledImg>  
                        <StyledBannerFonts >
                            <StyledBannerStrongFont>
                                {language[homeState.default_language]["sendFree"]}
                            </StyledBannerStrongFont>
                                {language[homeState.default_language]["allProduct"]}
                        </StyledBannerFonts> 
                        <StyledImgTwo>
                            <StyledCustomIcon color={props.color} />
                        </StyledImgTwo>  
                        <StyledCloseContainer>
                            <span onClick={() => setIsOpenBanner(false)}>
                                <StyledClose color={props.color}/>
                            </span>
                       </ StyledCloseContainer>
                    </StyledContentContainer>

                </div>
            </div>
        </StyledBanner> 
        </>

    )
}

export default BannerFreeDelivery